import { useEffect, useState } from "react";
import Api from "../Services/Api";
import "./performaceVendas.css";

const PerformaceVendas = () => {
  const [dados, setDados] = useState({
    vendas_mes: 0,
    confirmado_mes: 0,
    analise_mes: 0,
    comparacao: { vendas_pct: 0, confirmado_pct: 0, analise_pct: 0 },
  });

  useEffect(() => {
    Api.get("/ledger-entries/me/performance")
      .then((res) => setDados(res.data))
      .catch((err) => console.error(err));
  }, []);

  const formatBRL = (v) =>
    Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const formatPct = (p) => {
    const n = Number(p || 0);
    const sign = n > 0 ? "+" : "";
    return `${sign}${n}%`;
  };

  const pctClass = (p) => (Number(p || 0) >= 0 ? "pct-up" : "pct-down");

  return (
    <article className="card">
      <div className="card-header">
        <div className="card-title">
          <span>📊</span>
          <span>Performance de vendas</span>
        </div>
      </div>

      <div className="card-body">
        <div>
          <strong>Vendas no mês:</strong>{" "}
          <span>{dados.vendas_mes}</span>{" "}
          <span className={`pct ${pctClass(dados.comparacao.vendas_pct)}`}>
            {formatPct(dados.comparacao.vendas_pct)}
          </span>
        </div>

        <div>
          <strong>Saldo confirmado (mês):</strong>{" "}
          <span>{formatBRL(dados.confirmado_mes)}</span>{" "}
          <span className={`pct ${pctClass(dados.comparacao.confirmado_pct)}`}>
            {formatPct(dados.comparacao.confirmado_pct)}
          </span>
        </div>

        <div>
          <strong>Saldo aguardando confirmação (mês):</strong>{" "}
          <span>{formatBRL(dados.analise_mes)}</span>{" "}
          <span className={`pct ${pctClass(dados.comparacao.analise_pct)}`}>
            {formatPct(dados.comparacao.analise_pct)}
          </span>
        </div>

        <div className="card-sub">Comparação automática com o mês anterior.</div>
      </div>

      <div className="card-footer-inline">
        <button className="secondary-btn" id="btnGoToLeads">
          Cadastrar leads
        </button>
      </div>
    </article>
  );
};

export default PerformaceVendas;
